<app-loading *ngIf="isLoading"></app-loading>
<ng-container *ngIf="!isLoading">
  <div class="policyInquiry">
    <div class="d-flex">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 titleContent">
        <label>{{
          "claimOffice.policyInquiry.policyEnquiry" | translate
        }}</label>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 text-right">
        <img
          class="close"
          src="{{ RESOURCE_SERVER_URL }}/assets/images/Close.svg" alt="Close Icon"
          (click)="onClose()"
        />
      </div>
    </div>
    <ng-container>
      <div class="dialog-content m-2">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="card-section contract-number">
              <div class="detail">
                <img
                  src="{{
                    RESOURCE_SERVER_URL
                  }}/assets/images/Policy_Enquiry_Asset/Contract_Number.svg"
                  alt=""
                />
                <div>
                  <p class="mt-2 mb-1">
                    {{ "claimOffice.policyInquiry.contactNum" | translate }}
                  </p>
                  <label>{{ policyData.policyNumber }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="card-section contract-name">
              <div class="detail">
                <img
                  src="{{
                    RESOURCE_SERVER_URL
                  }}/assets/images/Policy_Enquiry_Asset/Contract_Name.svg"
                  alt=""
                  srcset=""
                />
                <div>
                  <p class="mt-2 mb-1">
                    {{ "claimOffice.policyInquiry.contractName" | translate }}
                  </p>
                  <label>{{ policyData.policyCntTypeDesc }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="card-section contract-status">
              <div class="detail">
                <img
                  src="{{
                    RESOURCE_SERVER_URL
                  }}/assets/images/Policy_Enquiry_Asset/Contract_Status.svg"
                  alt=""
                  srcset=""
                />
                <div>
                  <p class="mt-2 mb-1">
                    {{ "claimOffice.policyInquiry.contractStatus" | translate }}
                  </p>
                  <label>{{ policyData.policyStatus }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div class="card-section premium-status">
              <div class="detail">
                <img
                  src="{{
                    RESOURCE_SERVER_URL
                  }}/assets/images/Policy_Enquiry_Asset/Premium_Status.svg"
                  alt=""
                  srcset=""
                />
                <div>
                  <p class="mt-2 mb-1">
                    {{ "claimOffice.policyInquiry.premiumStatus" | translate }}
                  </p>
                  <label>{{ policyData.policyPremiumStatus }} </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container>
          <div class="plan-details my-2">
            <div class="pt-3 pl-5 pb-2 pr-5">
              <div class="row subTitle">
                <p>
                  {{
                    "claimOffice.policyInquiry.detailsOfPlanApplied" | translate
                  }}
                </p>
              </div>

              <div class="row text-left mt-3 plan-detail-content">
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right p-0"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Contract_Owner.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.contractOwner" | translate
                      }}</label>
                      <p>{{ policyData.policyClientNumber }}</p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1"
                        >{{ "claimOffice.policyInquiry.ownerName" | translate }}
                      </label>
                      <p>
                        {{
                          policyData.policyOwnerName == ""
                            ? "-"
                            : policyData.policyOwnerName
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right mobPlan"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Life_Assured.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.lifeAssured" | translate
                      }}</label>
                      <p>
                        {{
                          policyData.policyClientNumber == ""
                            ? "-"
                            : policyData.policyClientNumber
                        }}
                      </p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.lifeAssuredName" | translate
                      }}</label>
                      <p>
                        {{
                          policyData.policyLifeInsured == ""
                            ? "-"
                            : policyData.policyLifeInsured
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right plan-detail-padding"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Joint_Owner.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.jointOwner" | translate
                      }}</label>
                      <p>-</p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.jointOwnerName" | translate
                      }}</label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right plan-detail-padding mobPlan"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Payor.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.payor" | translate
                      }}</label>
                      <p *ngIf="policyData.policyPayers != ''">
                        {{
                          policyData.policyPayers[0].partyClientNumber == ""
                            ? "-"
                            : policyData.policyPayers[0].partyClientNumber
                        }}
                      </p>
                      <p *ngIf="policyData.policyPayers == ''">-</p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1"
                        >{{ "claimOffice.policyInquiry.payorName" | translate }}
                      </label>
                      <p *ngIf="policyData.policyPayers != ''">
                        {{
                          policyData.policyPayers[0].partyName == ""
                            ? "-"
                            : policyData.policyPayers[0].partyName
                        }}
                      </p>
                      <p *ngIf="policyData.policyPayers == ''">-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right plan-detail-padding"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Joint_Life.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1">{{
                        "claimOffice.policyInquiry.jointLife" | translate
                      }}</label>
                      <p>-</p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1"
                        >{{
                          "claimOffice.policyInquiry.jointLifeName" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 plan-detail-padding mobPlan"
                >
                  <div class="plan-detail-description">
                    <img
                      src="{{
                        RESOURCE_SERVER_URL
                      }}/assets/images/Policy_Enquiry_Asset/Assignee.svg"
                      alt=""
                    />
                    <div>
                      <label class="mt-3 mb-1"
                        >{{ "claimOffice.policyInquiry.assignee" | translate }}
                      </label>
                      <p>-</p>
                    </div>
                    <div>
                      <label class="mt-3 mb-1"
                        >{{
                          "claimOffice.policyInquiry.assigneeName" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-left mt-2 plan-detail-content">
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right p-0"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{ "claimOffice.policyInquiry.currency" | translate }}
                      </label>
                      <p>{{currencyCode}}
                        <!-- {{
                          policyData.policyBillingCurrency == ""
                            ? "-"
                            : policyData.policyBillingCurrency
                        }} -->
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 plan-detail-padding mobPlan"
                >
                  <div class="plan-detail-description mobRegister">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{ "claimOffice.policyInquiry.register" | translate }}
                      </label>
                      <p>{{countrycode}}
                        <!-- {{
                          policyData.policyRegister == ""
                            ? "-"
                            : policyData.policyRegister
                        }} -->
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-0 subTitle">
                  <p>
                    {{
                      "claimOffice.policyInquiry.billing&PaymentDetails"
                        | translate
                    }}
                  </p>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <a class="link-item">View Scheduled Dates</a>
                </div>
              </div>

              <div class="row text-left plan-detail-content">
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right p-0"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1">{{
                        "claimOffice.policyInquiry.billingCurrency" | translate
                      }}</label>
                      <p>{{currencyCode}}
                        <!-- {{
                          policyData.policyBillingCurrency == ""
                            ? "-"
                            : policyData.policyBillingCurrency
                        }} -->
                      </p>
                    </div>
                    <div>
                      <label class="mt-4 mb-1">{{
                        "claimOffice.policyInquiry.paymentMethod" | translate
                      }}</label>
                      <p>
                        {{
                          policyData.policyPaymentMethod == ""
                            ? "-"
                            : policyData.policyPaymentMethod
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right mobPlan"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.nonForfeitureOption"
                            | translate
                        }}
                      </label>

                      <p>
                        {{
                          policyData.policyNonForfeitureOption == ""
                            ? "-"
                            : policyData.policyNonForfeitureOption
                        }}
                      </p>
                    </div>
                    <div>
                      <label class="mt-2 mb-1"
                        >{{
                          "claimOffice.policyInquiry.payoutMethod" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right mobPlanDetail"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.servicingAgent" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                    <div class="refund">
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.refundOverpayPremium"
                            | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right mobPlan"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.autoIncrease" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.bankOutlet" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-6 col-sm-12 border-right mobPlanDetail"
                >
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.fATCAStatus" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.bankServiceManager"
                            | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12 mobPlan">
                  <div class="plan-detail-description">
                    <div>
                      <label class="mt-4 mb-1"
                        >{{ "claimOffice.policyInquiry.branch" | translate }}
                      </label>
                      <p>
                        {{
                          policyData.branchName == ""
                            ? "-"
                            : policyData.branchName
                        }}
                      </p>
                    </div>
                    <div>
                      <label class="mt-4 mb-1"
                        >{{
                          "claimOffice.policyInquiry.bankTeller" | translate
                        }}
                      </label>
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pl-3 pr-3">
              <custom-accordion
                id="viewPlan"
                label="{{
                  'claimOffice.policyInquiry.viewPlanComponent' | translate
                }}"
                [childTemplate]="childTemplate"
                (onClick)="accordionClicked($event)"
                [isExpanded]="isViewPlan"
              >
              </custom-accordion>
              <custom-accordion
                label="{{
                  'claimOffice.policyInquiry.claimEnquiry' | translate
                }}"
              >
              </custom-accordion>
            </div>

            <!--View Plan Componets-->
            <div class="container-view">
              <ng-template #childTemplate>
                <ng-container>
                  <div class="plan card my-5 mx-3 accord">
                    <div class="content-view">
                      <div class="row plan-content">
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view"
                        >
                          <div class="plan-description view-r">
                            <label>{{
                              "claimOffice.policyInquiry.contactNum" | translate
                            }}</label>
                            <p>
                              {{
                                policyData.policyNumber == ""
                                  ? "-"
                                  : policyData.policyNumber
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view mobContract"
                        >
                          <div class="plan-description view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.contractDescription"
                                  | translate
                              }}</label
                            >
                            <p>
                              {{
                                policyData.policyDescription == ""
                                  ? "-"
                                  : policyData.policyDescription
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view mobViewCard"
                        >
                          <div class="plan-description view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.register" | translate
                              }}</label
                            >
                            <p>{{countrycode}}
                              <!-- {{
                                policyData.policyRegister == ""
                                  ? "-"
                                  : policyData.policyRegister
                              }} -->
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view-end mobViewCard"
                        >
                          <div class="plan-description view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.premiumStatus"
                                  | translate
                              }}</label
                            >
                            <p>
                              {{
                                policyData.policyPremiumStatus == ""
                                  ? "-"
                                  : policyData.policyPremiumStatus
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4 plan-content">
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view"
                        >
                          <div class="plan-description view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.currency" | translate
                              }}</label
                            >
                            <p>{{currencyCode}}
                              <!-- {{
                                policyData.policyCurrency == ""
                                  ? "-"
                                  : policyData.policyCurrency
                              }} -->
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view mobContract"
                        >
                          <div class="plan-description view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.noOfPolicies"
                                  | translate
                              }}</label
                            >
                            <p>
                              {{
                                policyData.numberOfPolicies == ""
                                  ? "-"
                                  : policyData.numberOfPolicies
                              }}
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-view mobViewCard"
                        >
                          <div class="plan-description view-more view-r">
                            <label>
                              {{
                                "claimOffice.policyInquiry.viewMoreDetails"
                                  | translate
                              }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container>
                  <div class="mt-3">
                    <dxc-table
                      class="table-responsive-sm dashabordTable contactTable pb-4 pt-4"
                    >
                      <tr class="header-filter">
                        <th id="colCoverage">
                          <div class="d-flex">
                            {{
                              "claimOffice.policyInquiry.coverage" | translate
                            }}
                          </div>
                        </th>
                        <th id="colComponent">
                          <div class="d-flex">
                            {{
                              "claimOffice.policyInquiry.component" | translate
                            }}
                          </div>
                        </th>
                        <th id="colDescription">
                          <div class="d-flex">
                            {{
                              "claimOffice.policyInquiry.description"
                                | translate
                            }}
                          </div>
                        </th>
                        <th id="colRiskStatus">
                          <div class="d-flex">
                            {{
                              "claimOffice.policyInquiry.riskStatus" | translate
                            }}
                          </div>
                        </th>
                        <th id="colPremiumStatus">
                          <div class="d-flex">
                            {{
                              "claimOffice.policyInquiry.premiumStatus"
                                | translate
                            }}
                          </div>
                        </th>
                      </tr>

                      <tr>
                        <td>
                          <span class="mobile-label">
                            {{
                              "claimOffice.policyInquiry.coverage" | translate
                            }}</span
                          ><span>{{ "01" }} </span>
                        </td>
                        <td>
                          <span class="mobile-label">
                            {{
                              "claimOffice.policyInquiry.component" | translate
                            }}</span
                          >
                          <span>{{ policyData.policyClientNumber }}</span>
                        </td>
                        <td>
                          <span class="mobile-label">
                            {{
                              "claimOffice.policyInquiry.description"
                                | translate
                            }}</span
                          ><span>{{ policyData.policyLifeInsured }}</span>
                        </td>
                        <td>
                          <span class="mobile-label">{{
                            "claimOffice.policyInquiry.riskStatus" | translate
                          }}</span
                          ><span>-</span>
                        </td>
                        <td>
                          <span class="mobile-label">
                            {{
                              "claimOffice.policyInquiry.premiumStatus"
                                | translate
                            }}</span
                          >
                          <span>-</span>
                        </td>
                      </tr>
                      <ng-container *ngIf="policyData.policyInsureds != ''">
                        <tr
                          *ngFor="
                            let coverages of policyData.policyInsureds[0]
                              .policyCoverage
                          "
                        >
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.coverage" | translate
                              }}</span
                            ><span>{{ coverages.coverageId }}</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.component"
                                  | translate
                              }}</span
                            >
                            <span>{{ coverages.coverageBenefitCode }}</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.description"
                                  | translate
                              }}</span
                            ><span>{{ coverages.coverageName }}</span>
                          </td>
                          <td>
                            <span class="mobile-label">{{
                              "claimOffice.policyInquiry.riskStatus" | translate
                            }}</span
                            ><span>{{ coverages.coverageRiskStatus }}</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.premiumStatus"
                                  | translate
                              }}</span
                            >
                            <span>{{ coverages.coveragePremiumStatus }}</span>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="policyData.policyInsureds == ''">
                        <tr>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.coverage" | translate
                              }}</span
                            ><span>-</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.component"
                                  | translate
                              }}</span
                            >
                            <span>-</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.description"
                                  | translate
                              }}</span
                            ><span>-</span>
                          </td>
                          <td>
                            <span class="mobile-label">{{
                              "claimOffice.policyInquiry.riskStatus" | translate
                            }}</span
                            ><span>-</span>
                          </td>
                          <td>
                            <span class="mobile-label">
                              {{
                                "claimOffice.policyInquiry.premiumStatus"
                                  | translate
                              }}</span
                            >
                            <span>-</span>
                          </td>
                        </tr>
                      </ng-container>
                    </dxc-table>
                  </div>
                </ng-container></ng-template
              >
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
